var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 4H10.6667C6.98477 4 4 6.98477 4 10.6667V21.3333C4 25.0152 6.98477 28 10.6667 28H21.3333C25.0152 28 28 25.0152 28 21.3333V10.6667C28 6.98477 25.0152 4 21.3333 4ZM25.6667 21.3333C25.6593 23.7235 23.7235 25.6593 21.3333 25.6667H10.6667C8.27647 25.6593 6.34065 23.7235 6.33333 21.3333V10.6667C6.34065 8.27647 8.27647 6.34065 10.6667 6.33333H21.3333C23.7235 6.34065 25.6593 8.27647 25.6667 10.6667V21.3333ZM22.3333 11C23.0697 11 23.6667 10.403 23.6667 9.66667C23.6667 8.93029 23.0697 8.33333 22.3333 8.33333C21.5969 8.33333 21 8.93029 21 9.66667C21 10.403 21.5969 11 22.3333 11ZM16 10C12.6863 10 10 12.6863 10 16C10 19.3137 12.6863 22 16 22C19.3137 22 22 19.3137 22 16C22.0036 14.4076 21.3725 12.8794 20.2465 11.7534C19.1205 10.6275 17.5924 9.99645 16 10ZM12.3333 16C12.3333 18.0251 13.9749 19.6667 16 19.6667C18.0251 19.6667 19.6667 18.0251 19.6667 16C19.6667 13.9749 18.0251 12.3333 16 12.3333C13.9749 12.3333 12.3333 13.9749 12.3333 16Z",
    fill: "black",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.4931cc5daba0912ed97f6620d8c7408c.svg";
export { ForwardRef as ReactComponent };